import {useCallback, useEffect} from "react";
import {batch, useComputed, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals";
import { marketOverview } from "../@signals";
import { useMarketAnalyzerRoleConfig } from "Pages/Pricing/MarketAnalyzer/@hooks";
import {
	marketAnalyzerEvolutionSkuFilters, marketAnalyzerEvolutionOffersFilters, marketAnalyzerSkuDetailsFilters,
	marketAnalyzerSubmittedFilters
} from "../../../@signals";
import {DISPLAY_TABS, RETAILER_DISPLAY_TABS} from "../@constants";

export default function usePricingMarketTableData() {
	const { urlApiTable, isRetailerUser } = useMarketAnalyzerRoleConfig()
	const isLoading = useSignal(false)
	const data = useSignal([])
	const countries = useSignal([])
	const selectedCountry = useSignal(null)
	const displayTable = useSignal(isRetailerUser ? RETAILER_DISPLAY_TABS.CURRENT_PRICE : DISPLAY_TABS.ACTUAL_PRICE)

	const currentData = useComputed(() => data.value[selectedCountry.value] || [])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			marketAnalyzerEvolutionSkuFilters.value = {}
			marketAnalyzerSkuDetailsFilters.value = {}
			marketAnalyzerEvolutionOffersFilters.value = {}
			postSubmit(`${urlApiTable}/market-comparison`, { ...commonFiltersValue.value }).then(res => batch(() => {
				marketAnalyzerSubmittedFilters.value = commonFiltersValue.peek()
				data.value = res.marketComparison
				countries.value = res.marketComparisonCountries
				selectedCountry.value = res.marketComparisonCountries[0]
				marketOverview.value = res.marketOverview
			})).catch(() => isSystemBusy.value = true
			).finally(() => batch(() => {
				isLoading.value = false
				isLoadingCommonFilters.value = false
			}))
		}
	}, [isLoadingCommonFilters.value]);

	const handleSelectedCountry = useCallback(newValue => {
		selectedCountry.value = newValue
	}, [])

	const handleChangeTabs = (_, newValue) => {
		displayTable.value = newValue
	}

	return {
		isLoading: isLoading.value,
		data: data.value,
		countries: countries.value,
		selectedCountry: selectedCountry.value,
		currentData: currentData.value,
		exceedLimit: currentData.value.length > 1000,
		displayTable: displayTable.value,

		handleSelectedCountry,
		handleChangeTabs
	}
}